import { Stack, Text, cn } from '@eluve/components';

interface PanelHeaderProps {
  title: React.ReactNode;
  sticky?: boolean;
  cornerRadius?: 'tl' | 'tr' | 'none';
  action?: React.ReactNode;
}

export const PanelHeader: React.FC<PanelHeaderProps> = ({
  title,
  sticky = false,
  cornerRadius = 'none',
  action,
}) => {
  return (
    <Stack
      justify="between"
      className={cn(
        'h-12 border-b border-border-tertiary bg-bg-secondary px-3',
        sticky && 'sticky top-0 z-10',
        cornerRadius === 'tl' && 'rounded-tl-lg',
        cornerRadius === 'tr' && 'rounded-tr-lg',
      )}
      gap={2}
      direction="horizontal"
    >
      {typeof title === 'string' ? (
        <Text inline weight="semibold">
          {title}
        </Text>
      ) : (
        title
      )}
      {action}
    </Stack>
  );
};
